<template>
  <template v-if="this.isBoldXchangeAdmin || this.isGiftingLead">
    <Teleport to="#modal">
      <SlideOutRight
        @closeModal="closeSlideOutRight()"
        :open="showSlideOutRight"
      >
        <div class="tw-flex tw-flex-grow tw-flex-col tw-overflow-y-auto">
          <div class="tw-flex tw-flex-shrink-0 tw-items-center">
            <img
              class="tw-h-auto tw-w-full"
              src="../../../assets/svg/logos/Bold_Xchange_PrimaryLogo_White_LG.png"
              alt="Bold Xchange logo"
            />
          </div>
          <nav
            class="tw-mt-5 tw-flex tw-flex-1 tw-flex-col tw-divide-y tw-divide-gray-800 tw-overflow-y-auto tw-overflow-x-hidden"
            aria-label="Sidebar"
          >
            <ul
              role="list"
              class="tw-flex tw-flex-1 tw-flex-col tw-gap-y-7 tw-list-none tw-p-0 tw-m-0"
            >
              <li>
                <ul
                  role="list"
                  class="tw--mx-2 tw-space-y-1 tw-list-none tw-p-2 tw-m-0"
                >
                  <template v-if="isBoldXchangeAdmin">
                    <li
                      v-for="item in adminSlideoutNavigation"
                      :key="item.name"
                    >
                      <router-link
                        @click="closeSlideOutRight()"
                        v-if="!item.children"
                        :to="item.to"
                        :class="[
                          item.to === currentRoutePath
                            ? 'tw-bg-gray-50 tw-text-gray-900'
                            : 'hover:tw-bg-gray-50 hover:tw-text-gray-900 tw-text-white',
                          'tw-group tw-capitalize tw-flex tw-rounded-md tw-p-2 tw-text-sm tw-leading-6 tw-font-semibold ',
                        ]"
                      >
                        <b-icon-house
                          v-if="item.name === 'dashboard'"
                          :class="[
                            item.to === currentRoutePath
                              ? 'tw-text-gray-900'
                              : 'group-hover:tw-text-gray-900 tw-text-white',
                            'tw-mr-4 tw-h-6 tw-w-6 tw-flex-shrink-0 ',
                          ]"
                          aria-hidden="true"
                        ></b-icon-house>
                        <b-icon-stars
                          v-else-if="item.name === 'campaigns'"
                          :class="[
                            item.to === currentRoutePath
                              ? 'tw-text-gray-900'
                              : 'group-hover:tw-text-gray-900 tw-text-white',
                            'tw-mr-4 tw-h-6 tw-w-6 tw-flex-shrink-0 ',
                          ]"
                          aria-hidden="true"
                        ></b-icon-stars>
                        <b-icon-people
                          v-else-if="item.name === 'recipients'"
                          :class="[
                            item.to === currentRoutePath
                              ? 'tw-text-gray-900'
                              : 'group-hover:tw-text-gray-900 tw-text-white',
                            'tw-mr-4 tw-h-6 tw-w-6 tw-flex-shrink-0 ',
                          ]"
                          aria-hidden="true"
                        ></b-icon-people>
                        <b-icon-check-square
                          v-else-if="item.name === 'members'"
                          :class="[
                            item.to === currentRoutePath
                              ? 'tw-text-gray-900'
                              : 'group-hover:tw-text-gray-900 tw-text-white',
                            'tw-mr-4 tw-h-6 tw-w-6 tw-flex-shrink-0 ',
                          ]"
                          aria-hidden="true"
                        ></b-icon-check-square>
                        <b-icon-gift
                          v-else-if="item.name === 'gift cards'"
                          :class="[
                            item.to === currentRoutePath
                              ? 'tw-text-gray-900'
                              : 'group-hover:tw-text-gray-900 tw-text-white',
                            'tw-mr-4 tw-h-6 tw-w-6 tw-flex-shrink-0 ',
                          ]"
                          aria-hidden="true"
                        ></b-icon-gift>
                        <b-icon-buildings
                          v-else-if="item.name === 'vendors'"
                          :class="[
                            item.to === currentRoutePath
                              ? 'tw-text-gray-900'
                              : 'group-hover:tw-text-gray-900 tw-text-white',
                            'tw-mr-4 tw-h-6 tw-w-6 tw-flex-shrink-0 ',
                          ]"
                          aria-hidden="true"
                        ></b-icon-buildings>
                        {{ item.name }}
                      </router-link>
                    </li>
                  </template>
                  <template v-if="isGiftingLead">
                    <li
                      v-for="item in giftingLeadSlideoutNavigation"
                      :key="item.name"
                    >
                      <router-link
                        @click="closeSlideOutRight()"
                        v-if="!item.children"
                        :to="item.to"
                        :class="[
                          item.to === currentRoutePath
                            ? 'tw-bg-gray-50 tw-text-gray-900'
                            : 'hover:tw-bg-gray-50 hover:tw-text-gray-900 tw-text-white',
                          'tw-group tw-capitalize tw-flex tw-rounded-md tw-p-2 tw-text-sm tw-leading-6 tw-font-semibold ',
                        ]"
                      >
                        <b-icon-house
                          v-if="item.name === 'dashboard'"
                          :class="[
                            item.to === currentRoutePath
                              ? 'tw-text-gray-900'
                              : 'group-hover:tw-text-gray-900 tw-text-white',
                            'tw-mr-4 tw-h-6 tw-w-6 tw-flex-shrink-0 ',
                          ]"
                          aria-hidden="true"
                        ></b-icon-house>
                        <b-icon-stars
                          v-else-if="item.name === 'campaigns'"
                          :class="[
                            item.to === currentRoutePath
                              ? 'tw-text-gray-900'
                              : 'group-hover:tw-text-gray-900 tw-text-white',
                            'tw-mr-4 tw-h-6 tw-w-6 tw-flex-shrink-0 ',
                          ]"
                          aria-hidden="true"
                        ></b-icon-stars>
                        <b-icon-people
                          v-else-if="item.name === 'recipients'"
                          :class="[
                            item.to === currentRoutePath
                              ? 'tw-text-gray-900'
                              : 'group-hover:tw-text-gray-900 tw-text-white',
                            'tw-mr-4 tw-h-6 tw-w-6 tw-flex-shrink-0 ',
                          ]"
                          aria-hidden="true"
                        ></b-icon-people>
                        <b-icon-gift
                          v-else-if="item.name === 'gift cards'"
                          :class="[
                            item.to === currentRoutePath
                              ? 'tw-text-gray-900'
                              : 'group-hover:tw-text-gray-900 tw-text-white',
                            'tw-mr-4 tw-h-6 tw-w-6 tw-flex-shrink-0 ',
                          ]"
                          aria-hidden="true"
                        ></b-icon-gift>
                        {{ item.name }}
                      </router-link>
                    </li>
                  </template>
                </ul>
              </li>
              <!-- integrations -->
              <li>
                <div
                  class="tw-text-xs tw-font-bold tw-leading-6 tw-text-yellow-200"
                >
                  Other
                </div>
                <ul
                  role="list"
                  class="tw--mx-2 tw-space-y-1 tw-list-none tw-p-0 tw-m-0 tw-h-5"
                >
                  <li v-for="item in integrationsNavRoutes" :key="item.name">
                    <router-link
                      :to="item.to"
                      :class="[
                        item.to === currentRoutePath
                          ? 'tw-bg-gray-50 tw-text-gray-900 '
                          : 'hover:tw-bg-gray-50 hover:tw-text-gray-900 tw-text-white ',
                        'tw-group tw-capitalize tw-flex tw-rounded-md tw-p-2 tw-text-sm tw-leading-6 tw-font-semibold tw-items-center',
                      ]"
                    >
                      <b-icon-grid-3x3-gap
                        v-if="item.name === 'integrations'"
                        :class="[
                          item.to === currentRoutePath
                            ? 'tw-text-gray-900'
                            : 'group-hover:tw-text-gray-900 tw-text-white',
                          'tw-mr-4 tw-h-5 tw-w-5 tw-flex-shrink-0 ',
                        ]"
                        aria-hidden="true"
                      ></b-icon-grid-3x3-gap>
                      <img
                        v-else-if="item.name === 'google'"
                        class="tw-mr-4 tw-h-5 tw-w-auto tw-flex-shrink-0"
                        :class="[
                          item.to === currentRoutePath
                            ? 'tw-text-gray-900'
                            : 'group-hover:tw-text-gray-900 tw-text-white',
                          'tw-mr-4  tw-h-5 tw-w-5 tw-flex-shrink-0 ',
                        ]"
                        src="../../../assets/svg/brands/google-calendar.png"
                        alt=""
                      />
                      <img
                        v-else-if="item.name === 'office 365'"
                        class="tw-mr-4 tw-h-5 tw-w-auto tw-flex-shrink-0"
                        :class="[
                          item.to === currentRoutePath
                            ? 'tw-text-gray-900'
                            : 'group-hover:tw-text-gray-900 tw-text-white',
                          'tw-mr-4 tw-h-5 tw-w-5 tw-flex-shrink-0 ',
                        ]"
                        src="../../../assets/svg/brands/office365.png"
                        alt=""
                      />
                      <img
                        v-else-if="item.name === 'salesforce'"
                        class="tw-mr-4 tw-h-full tw-w-5 tw-flex-shrink-0"
                        :class="[
                          item.to === currentRoutePath
                            ? 'tw-text-gray-900'
                            : 'group-hover:tw-text-gray-900 tw-text-white',
                          'tw-mr-4 tw-h-full tw-w-5 tw-flex-shrink-0 ',
                        ]"
                        src="../../../assets/svg/brands/salesforce.png"
                        alt=""
                      />
                      {{ item.name }}
                    </router-link>
                  </li>
                </ul>
              </li>
            </ul>
          </nav>
        </div>
      </SlideOutRight>
    </Teleport>
  </template>
  <div
    class="tw-flex tw-h-16 tw-flex-shrink-0 tw-border-b tw-border-gray-200 tw-bg-gray-200 lg:tw-border-none"
  >
    <template v-if="this.isBoldXchangeAdmin || this.isGiftingLead">
      <button
        type="button"
        class="tw-border-none hover:tw-bg-blue-900 hover:tw-text-white tw-border-r tw-border-gray-200 tw-px-4 tw-text-gray-400 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-inset focus:tw-bg-blue-900 lg:tw-hidden"
        @click="toggleSlideOutRight"
      >
        <span class="tw-sr-only">Open main menu</span>
        <b-icon-list class="tw-h-6 tw-w-6" aria-hidden="true"></b-icon-list>
      </button>
    </template>
    <div
      class="tw-flex tw-flex-1 tw-justify-end tw-px-4 sm:tw-px-6 lg:tw-mx-auto lg:tw-px-8 tw-bg-stone-50 tw-border-b tw-border-stone-300 tw-border-0 tw-border-solid"
    >
      <div class="tw-ml-4 tw-flex tw-items-center md:tw-ml-6">
        <div class="tw-relative tw-ml-3">
          <div>
            <div class="tw-flex tw-items-center">
              <DropdownMenu
                :profileDropdown="true"
                :items="avatarDropdownItems()"
                :avatar="Avatar"
              >
              </DropdownMenu>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SlideOutRight from "../modals/SlideOutRight.vue";
import DropdownMenu from "../forms/DropdownMenu.vue";

export default {
  name: "TopNavigationBar",
  components: { SlideOutRight, DropdownMenu },
  props: {
    borderWidth: {
      type: Number,
      default: 25,
    },
    borderRadius: {
      type: Number,
      default: 200,
    },
    borderStyle: {
      type: String,
      default: "solid",
    },
    borderColor: {
      type: String,
      default: "",
    },
    padding: {
      type: [Number, Object],
      default: 400,
    },
    width: {
      type: [Number, Object],
      default: 100,
    },
    backgroundColor: {
      type: Boolean,
      default: true,
    },
    id: {
      type: String,
      default: "",
    },
    role: {
      default: null,
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      adminSlideoutNavigation: [
        { name: "dashboard", to: "/dashboard", current: false },
        { name: "campaigns", to: "/campaigns", current: false },
        { name: "recipients", to: "/recipients", current: false },
        { name: "members", to: "/members", current: false },
        { name: "gift cards", to: "/home", current: false },
        { name: "vendors", to: "/vendors", current: false },
      ],
      giftingLeadSlideoutNavigation: [
        { name: "dashboard", to: "/dashboard", current: false },
        { name: "campaigns", to: "/campaigns", current: false },
        { name: "recipients", to: "/recipients", current: false },
        { name: "gift cards", to: "/home", current: false },
      ],
      integrationsNavRoutes: [
        { name: "integrations", to: "/integrations", current: false },
        { name: "google", to: "/integrations/google", current: false },
        { name: "office 365", to: "/integrations/office365", current: false },
        { name: "salesforce", to: "/integrations/salesforce", current: false },
      ],
      isOpen: false,
      showSlideOutRight: false,
    };
  },
  computed: {
    User() {
      return this?.$store?.state?.auth?.user;
    },
    Avatar() {
      const url = this?.User?.photo;
      if (url) {
        if (url.indexOf("/") === 0) {
          return process.env.VUE_APP_API_BASE_URL + url;
        } else {
          return url;
        }
      } else {
        return `https://api.dicebear.com/7.x/initials/svg?seed=${this?.User?.firstName}%20${this?.User?.lastName}&backgroundColor=3949ab`;
      }
    },
    currentRoutePath() {
      return this.$route.path;
    },
  },
  methods: {
    async logout() {
      // this.$store.commit("auth/LOGOUT");
      // this.$router.push({ path: "/login" });

      await this.$store.dispatch("auth/logout").then(() => {
        this.$router.push({ path: "/login" });
      });
    },
    avatarDropdownItems() {
      return [
        {
          label: "Account",
          isRouterLink: true,
          to: "/account",
        },
        {
          label: "Your gifts",
          isRouterLink: true,
          to: "/gifts",
        },
        {
          label: "Logout",
          action: () => this.logout(),
        },
      ];
    },
    toggleDropdown() {
      this.isOpen = !this.isOpen;
      if (this.isOpen) {
        this.setupClickAwayListener();
      } else {
        this.removeClickAwayListener();
      }
    },
    toggleSlideOutRight() {
      this.showSlideOutRight = !this.showSlideOutRight;
    },
    closeSlideOutRight() {
      this.showSlideOutRight = false;
    },
    closeDropdown() {
      this.isOpen = false;
      this.removeClickAwayListener();
    },
    setupClickAwayListener() {
      document.addEventListener("click", this.handleClickAway);
    },
    removeClickAwayListener() {
      document.removeEventListener("click", this.handleClickAway);
    },
    handleClickAway(event) {
      const dropdown = this.$refs.dropdown;
      if (dropdown && !dropdown.contains(event.target)) {
        this.closeDropdown();
      }
    },
  },
};
</script>
